import React, {useState, useEffect} from 'react';
import {Box, Card, Button, Typography, ListItem, ListItemText, ListItemButton} from '@mui/material/';
import Grid from '@mui/material/Grid2';
import { Newsletter } from '../../../types/communication/newsletter';
import { useErrorBoundary } from 'react-error-boundary';
import FeedIcon from '@mui/icons-material/Feed';

const DisplayClerkCheckin = (): JSX.Element => {

  const { showBoundary } = useErrorBoundary();  
  const [newsletters, setNewsletters] = useState<Newsletter[]>();
  const [selectedNewsletter, setSelectedNewsletter] = useState<Newsletter>();

  useEffect(() => {
    getClerkCheckingInList();
  }, [])

  const getClerkCheckingInList = async () => {

    try{
      await fetch(`${process.env.REACT_APP_API_BASE_URL}/checkingin/`)
      .then(result => {
        if (!result.ok) {
          showBoundary(new Error('Failed to get clerk checking in list.'));
        }
        return result.json();
      })
      .then(result => {
        let count = result.length;
        if (count > 0){
            setNewsletters(result);
            setSelectedNewsletter(result[0]);
        }
      });
    }catch(error){
        console.error('Uncaught Error:', error);
        showBoundary(new Error(`${error}`));
    }
  }


  const updateNewsletter = (newsletter: Newsletter) => () => {
    setSelectedNewsletter(newsletter);
  }

  return (
    <Box marginTop={5} marginBottom={4}>
      <Box marginBottom={4}>
        <Typography
         variant="h6"
          sx={{
            textTransform: 'uppercase',
          }}
          data-aos={'fade-up'}
          fontWeight={700}
          gutterBottom
          color={'secondary'}
          align={'center'}
        >
          Municipal Clerk Monthly Informational Mailing
        </Typography>
      </Box>
      <Grid container spacing={4}>
        <Grid size={{xs:12, md:9}}>
          <Box
            padding={{ xs: 3, sm: 6 }}
            width={1}
            component={Card}
            boxShadow={4}
            data-aos="fade-up"
          >
             <iframe
                aria-label={'newsletter' + selectedNewsletter?.title}
                title={selectedNewsletter?.title}
                src={selectedNewsletter?.url} 
                width="100%" height="1200px">
              </iframe>
          </Box>
        </Grid>
        <Grid size={{xs:12, md:3}}>
          <Box
            padding={2}
            width={1}
            component={Card}
            boxShadow={4}
            data-aos="fade-up"
          >
              <Box>
                <Typography fontWeight={700} variant={'subtitle1'} gutterBottom>
                  Monthly Checking-In
                </Typography>
              </Box>
              {
                  newsletters?.map((newsletter, index) =>
                    <Grid size={12} key={newsletter.id} display="flex" justifyContent={"flex-start"}>
                      <Box
                        component={ListItem}
                        disableGutters
                        width={'auto'}
                        padding={0}
                      >
                        <Box
                          component={ListItemButton}
                          minWidth={'auto !important'}
                        >
                          <FeedIcon color="action" />
                        </Box>
                        <ListItemText primary={<Typography component={Button} variant='body2' onClick={updateNewsletter(newsletter)}>{newsletter.title}</Typography>} />
                      </Box>
                    </Grid>
                  )
              }
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DisplayClerkCheckin;
